import { render, staticRenderFns } from "./PreviewCreateFile.vue?vue&type=template&id=87b7dca8"
import script from "./PreviewCreateFile.vue?vue&type=script&lang=js"
export * from "./PreviewCreateFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports